import {
  AlertTriangle,
  Clock,
  FileText,
  MessageSquare,
  Users,
} from "lucide-react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";
import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "../../components/ui/chart";
import {
  CartesianGrid,
  Cell,
  Line,
  LineChart,
  Pie,
  PieChart,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from "recharts";
import { useEffect, useState } from "react";
import { getDashboardStats } from "../api/adminDashboard";

const Dashboard = () => {
  const [summaryStats, setSummaryStats] = useState([]);
  const [userGrowthData, setUserGrowthData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const data = await getDashboardStats();
        console.log("data from dashboard", data);

        const { summary, userGrowthData, categoryData } = data;

        // Format summary for cards
        const formattedSummary = [
          {
            title: "Total Users",
            value: summary.totalUsers.toLocaleString(),
            icon: Users,
            color: "text-blue-600",
          },
          {
            title: "Active Listings",
            value: summary.activeListings.toLocaleString(),
            icon: FileText,
            color: "text-green-600",
          },
          {
            title: "Pending Approvals",
            value: summary.pendingApprovals.toLocaleString(),
            icon: Clock,
            color: "text-orange-600",
          },
          {
            title: "Active Chats",
            value: summary.activeChats.toLocaleString(),
            icon: MessageSquare,
            color: "text-purple-600",
          },
          {
            title: "Reports This Week",
            value: summary.reportsThisWeek.toLocaleString(),
            icon: AlertTriangle,
            color: "text-red-600",
          },
        ];

        setSummaryStats(formattedSummary);
        setUserGrowthData(userGrowthData);
        setCategoryData(categoryData);
      } catch (error) {
        console.error("Failed to fetch dashboard stats:", error);
      }
    };

    fetchStats();
  }, []);

  const normalizedData = categoryData.map((item) => ({
    ...item,
    name: item.name || item._id || "Unknown",
  }));

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-gray-800">Dashboard</h2>
      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
        {summaryStats.map((stat, index) => {
          const Icon = stat.icon;
          return (
            <Card key={index} className="hover:shadow-md transition-shadow">
              <CardHeader className="flex !flex-row items-center justify-between space-y-0 pb-2">
                <CardTitle className="text-sm font-medium text-gray-600">
                  {stat.title}
                </CardTitle>
                <Icon className={`w-5 h-5 ${stat.color}`} />
              </CardHeader>
              <CardContent>
                <div className="text-2xl font-bold">{stat.value}</div>
              </CardContent>
            </Card>
          );
        })}
      </div>

      {/* Charts Section */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Users Over Time */}
        <Card>
          <CardHeader>
            <CardTitle>Users Over Time</CardTitle>
          </CardHeader>
          <CardContent>
            <ChartContainer
              config={{ users: { label: "Users", color: "#3b82f6" } }}
              className="h-64"
            >
              <ResponsiveContainer width="100%" height="100%">
                <LineChart data={userGrowthData}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="month" />
                  <YAxis />
                  <ChartTooltip content={<ChartTooltipContent />} />
                  <Line
                    type="monotone"
                    dataKey="users"
                    stroke="#3b82f6"
                    strokeWidth={2}
                    dot={{ fill: "#3b82f6", strokeWidth: 2, r: 4 }}
                  />
                </LineChart>
              </ResponsiveContainer>
            </ChartContainer>
          </CardContent>
        </Card>

        {/* Listings by Category */}
        <Card>
          <CardHeader>
            <CardTitle>Listings by Category</CardTitle>
          </CardHeader>
          <CardContent>
            <ChartContainer config={{}} className="h-64">
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie
                    data={normalizedData}
                    cx="50%"
                    cy="50%"
                    outerRadius={80}
                    dataKey="value"
                    label={({ name, value }) => {
                      const total = normalizedData.reduce(
                        (sum, entry) => sum + entry.value,
                        0
                      );
                      const percent = ((value / total) * 100).toFixed(0);
                      return `${name}: ${percent}%`;
                    }}
                  >
                    {normalizedData.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={entry.color} />
                    ))}
                  </Pie>
                  <ChartTooltip content={<ChartTooltipContent />} />
                </PieChart>
              </ResponsiveContainer>
            </ChartContainer>
          </CardContent>
        </Card>
      </div>

      {/* Recent Activity Feed */}
      {/* <Card>
        <CardHeader>
          <CardTitle>Recent Activity</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-3">
            {recentActivity.map((activity, index) => (
              <div
                key={index}
                className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg"
              >
                <span className="text-lg">
                  {getActivityIcon(activity.type)}
                </span>
                <div className="flex-1">
                  <p className="font-medium">{activity.user}</p>
                  <p className="text-sm text-gray-600">{activity.action}</p>
                </div>
                <span className="text-xs text-gray-500">{activity.time}</span>
              </div>
            ))}
          </div>
        </CardContent>
      </Card> */}
    </div>
  );
};

export default Dashboard;
